window._ = require('lodash')

import GrowingTextarea from './classes/GrowingTextarea'

require('./modernizr.js')
require('./bootstrap.js')

require('./vue.js')

window.moment = require('moment')
window.moment.locale(window.lang)

window.Vapor = require('laravel-vapor')

window.addEventListener('load', () => {
  if (window.navigator.standalone) {
    document.querySelector('body').classList.add('standalone')
  }

  document.querySelectorAll('[data-toggle]').forEach((element) => {
    element.addEventListener('click', (e) => {
      document.getElementById(element.getAttribute('data-toggle')).classList.toggle('hidden')
    })
  })

  document.querySelectorAll('.select-all, .select-none').forEach((element) => {
    element.addEventListener('click', (e) => {
      element
        .closest('.selection-container')
        .querySelectorAll('input[type="checkbox"]')
        .forEach((checkbox) => {
          checkbox.checked = element.classList.contains('select-all')
        })
    })
  })

  document.querySelectorAll('[data-href]').forEach((element) => {
    element.addEventListener('click', (e) => {
      document.location = element.dataset.href
    })
  })

  document.querySelectorAll('textarea.growing').forEach((textarea) => {
    textarea.oninput = () => GrowingTextarea.grow(textarea)
    GrowingTextarea.grow(textarea)
  })
})
